/*
  Small vertical dot indicator, fixed right side, showing which
  full-screen section is currently active in the snap-scroll container.
  Purely visual - updates via IntersectionObserver watching each section.
*/

export function renderScrollDots(sectionIds) {
  const wrapper = document.createElement('div');
  wrapper.className = 'fixed right-6 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-3';

  // 'section-2' (About) gets a diamond instead of a circle - explicit
  // id check, not a positional/last-index assumption, so this stays
  // correct even if section order or count changes later.
  const shapeClass = (id) => (id === 'section-2' ? 'rounded-[1px] rotate-45' : 'rounded-full');

  const dots = sectionIds.map((id) => {
    const dot = document.createElement('div');
    dot.className = `w-2 h-2 ${shapeClass(id)} border border-neutral-400 transition-colors`;
    wrapper.appendChild(dot);
    return dot;
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const idx = sectionIds.indexOf(entry.target.id);
        if (idx === -1) return;
        if (entry.isIntersecting) {
          dots.forEach((d, i) => {
            const shape = shapeClass(sectionIds[i]);
            d.className = i === idx
              ? `w-2 h-2 ${shape} bg-neutral-100 border border-neutral-100 transition-colors`
              : `w-2 h-2 ${shape} border border-neutral-400 transition-colors`;
          });
        }
      });
    },
    { threshold: 0.6 }
  );

  sectionIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

  return wrapper;
}
